/* unplugin-vue-components disabled */import { render } from "./PageHead.vue?vue&type=template&id=41d15a2c&scoped=true"
import script from "./PageHead.vue?vue&type=script&lang=js"
export * from "./PageHead.vue?vue&type=script&lang=js"

import "./PageHead.vue?vue&type=style&index=0&id=41d15a2c&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-41d15a2c"]])

export default __exports__